import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createFaq, deleteFaq, getFaqList, updateFaq } from "../../../redux/actions/contentAction";
import { allValidations } from "../../../utils/formValidations";
import { showFormErrors } from "../../../utils/commonFunctions";
import { confirmPopup } from "primereact/confirmpopup";

export default function Index() {
    const dispatch = useDispatch();
    let { faq } = useSelector((state) => state.content);

    const [faqData, setFaqData] = useState({
        _id: null,
        question: "",
        answer: "",
    });

    const [faqDialogVisible, setFaqDialogVisible] = useState(false);

    useEffect(() => {
        dispatch(getFaqList());
    }, [dispatch]);

    const editFaq = (faq) => {
        setFaqData({ ...faq });
        setFaqDialogVisible(true);
    };

    const handleFaqChange = ({ name, value }) => {
        let formErrors = {};
        formErrors = allValidations(name, value, faqData);
        setFaqData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const addUpdateFaq = () => {
        if (showFormErrors(faqData, setFaqData)) {
            if (faqData._id) {
                dispatch(updateFaq(faqData, onHideForm));
            } else {
                dispatch(createFaq(faqData, onHideForm));
            }
        }
    };

    const resetFaqForm = () => {
        setFaqData({
            _id: null,
            question: "",
            answer: "",
        });
    };

    const onHideForm = () => {
        setFaqDialogVisible(false);
        resetFaqForm();
    };

    const onDeleteFaq = (e, id) => {
        confirmPopup({
            target: e.currentTarget,
            message: "Are you sure you want to delete this faq? This action will permanently delete this. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteFaq(id)),
            reject: () => {},
        });
    };

    return {
        faq,
        faqData,
        faqDialogVisible,
        setFaqDialogVisible,
        editFaq,
        handleFaqChange,
        addUpdateFaq,
        onHideForm,
        onDeleteFaq,
    };
}
